// frontend/src/locales/locales.ts
// Add new languages here once and reuse everywhere.
export const SUPPORTED_LANGUAGES = ["en", "de"] as const;
export type Language = typeof SUPPORTED_LANGUAGES[number];

export const isLanguage = (v: unknown): v is Language =>
  typeof v === "string" && (SUPPORTED_LANGUAGES as readonly string[]).includes(v);

export const normalizeLanguage = (v: unknown): Language | undefined =>
  isLanguage(v) ? v : undefined;

export const DEFAULT_LANGUAGE: Language = "en";